import 'highlight.js/styles/github.css';
import hljs from 'highlight.js';
hljs.configure({ languages: ['ruby', 'erb', 'bash', 'javascript'] });